<template>
  <FloatLabel variant="on" class="chat-widget__music-title chat-widget__w-100">
    <div class="chat-widget__music-title-wrapper">
      <div class="chat-widget__music-title-input-wrapper">
        <InputText
            type="text"
            class="chat-widget__music-title-input"
            inputId="on_music_title"
            v-model="userInput.musicTitle"
        />
        <i v-if="userInput.musicTitle"
           class="pi pi-times chat-widget--cursor-pointer chat-widget__music-title--clear"
           @click="clearInput"/>
      </div>
    </div>
    <label for="on_music_title">Название песни (опционально)</label>
  </FloatLabel>
</template>

<script setup>
import InputText from 'primevue/inputtext';
import FloatLabel from "primevue/floatlabel";
import {useInputStore} from '@/modules/chat/stores/userInputStore';

const userInput = useInputStore();

const clearInput = () => {
  userInput.musicTitle = '';
};
</script>